// extracted by mini-css-extract-plugin
export default {"back":"BackButton_back__45XpX","back__icon":"BackButton_back__icon__1G9Ux"};